<script setup>
import ExposureStatusSplash from "@/features/ExposureStatus/ExposureStatusSplash.vue";
import ExposureStatusBrokerList from "@/features/ExposureStatus/ExposureStatusBrokerList.vue";
import { useDisplay } from "@/composables/useDisplay";

const { isMobile } = useDisplay();

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  isEnrolled: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <ExposureStatusBrokerList v-if="isEnrolled && !isMobile" />
    <ExposureStatusSplash
      :is-loading="isLoading"
      :is-enrolled="isEnrolled"
    />
  </div>
</template>
